import { App } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { IconDefinition, library } from '@fortawesome/fontawesome-svg-core';
import { faCubes } from '@fortawesome/free-solid-svg-icons/faCubes';
import { faCube } from '@fortawesome/free-solid-svg-icons/faCube';
import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faGoogle } from '@fortawesome/free-brands-svg-icons/faGoogle';

library.add(
  faCubes as IconDefinition,
  faCube as IconDefinition,
  faGithub as IconDefinition,
  faGoogle as IconDefinition
);

export default (app: App) => {
  {
    app.component('FaIcon', FontAwesomeIcon);
  }
};
